import React from 'react';
import FormData from './Litigation';
import VerifyModal from './components/modals/VerifyModal';
import './Litigation.scss';

const ShowLitigation = ({
  defaultData,
  isModalVerifyOpen,
  setIsModalVerifyOpen,
}) => {

  return (
    <div style={{width: '100%'}}>
      <FormData defaultData={defaultData} />
      <VerifyModal
        open={isModalVerifyOpen}
        id={defaultData?.risk.id}
        isOpen={(e) => setIsModalVerifyOpen(e)}
      />
    </div>
  );
};

export default ShowLitigation;
